import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Link from "./link"
import { htmlDecode } from "../Utils"

const AwardsBlock = ({
  key,
  heading=null,
  subText=null,
  backgroundColor="white",
  grayscale=true,
  showTitle=false,
  showDescription=false
}) => {

    const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

    return (
        <StaticQuery
            query={graphql`
        query AwardsQuery {
          allStrapiNews(
            sort: {fields: publicationDate, order: DESC}
            filter: {news_category: {slug: {eq: "awards"}}, showInArchive: {ne: false}}
          ) {
            edges {
              node {
                title
                content
                featuredImage {
                  formats {
                    small {
                      url
                    }
                  }
                  url
                }
                link
              }
            }
          }
        }
      `}
        render={data => (
            <div className={ `our-awards bg-${backgroundColor}` }>
                <div className="container">
                    <div className="row jcc acc">
                        <div className="col-sm-12 col-md-6">
                            {heading &&
                            <h2 className={ `content-title text-center ${subText ? "orange-dash" : "mb4"}` }>{ htmlDecode(heading) }</h2>
                            }
                            {subText &&
                            <div className="section-content text-center mb4" dangerouslySetInnerHTML={{ __html: subText }} />
                            }
                        </div>
                    </div>
                    <div className="row jcc">
                        <div id="awardsSlider" className="flexslider" style={{width: "100%"}}>
                            <ul className="slides">
                                {data.allStrapiNews.edges && data.allStrapiNews.edges.map(({ node }) => (
                                    <li className="slide list-item">
                                        <div className="slider_list-item-inner">
                                            <div className="list-content bgw br3 ofh bs1">
                                                <div className="slider_content-wrap">
                                                    {node.featuredImage &&
                                                    <Link href={ node.link }>
                                                        <div className="image-wrap brdr1--bottom bcg3">
                                                            <img className={ `list-content_image-wrap img-responsive` } alt={ node.featuredImage?.alternativeText } src={node.featuredImage.url.includes(cdnUrl) ? node.featuredImage.url : cdnUrl + node.featuredImage.url} />
                                                        </div>
                                                    </Link>
                                                    }
                                                    <div className="teaser-text-wrap">
                                                        {(showTitle && node.title) &&
                                                        <>
                                                            <Link href={node.link} target="_blank">
                                                                <h3 className="teaser-header mb1.8">{node.title}</h3>
                                                            </Link>
                                                        </>
                                                        }
                                                        {(showTitle && node.title) && (showDescription && node.content) &&
                                                            <hr className="small orange mb1.8 ml0"/>
                                                        }
                                                        {(showDescription && node.content) &&
                                                            <p className="copy">
                                                                {htmlDecode(node.content).substr(0, 80)}&hellip;
                                                            </p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="slider_button-wrap">
                                                    <Link className="button uppercase" href={ node.link } target="_blank">View Award</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-sm-12 col-md-6 tac">
                            <Link className="button uppercase mt3" href="/awards" target="_blank">View All Awards</Link>
                        </div>
                    </div>
                </div>
            </div>
        )}
    />
    )
}

export default AwardsBlock
